import React, { useEffect, useRef } from "react";
import { Column, ColumnConfig } from "@ant-design/plots";

export default function BarChart() {
  const chartRef = useRef<any | null>(null);

  useEffect(() => {
    console.log({ chartRef });
    if (chartRef.current) {
      // You can call chart methods here, e.g., chartRef.current.changeData(newData)
    }
  }, []);

  // Hardcoded data
  const data = [
    { city: "Beijing", sales: 350, country: "China" },
    { city: "Shanghai", sales: 420, country: "China" },
    { city: "Guangzhou", sales: 300, country: "China" },
    { city: "Shenzhen", sales: 500, country: "China" },
    { city: "Hangzhou", sales: 280, country: "China" },
    { city: "Chengdu", sales: 330, country: "China" },
    { city: "Wuhan", sales: 290, country: "China" },
    { city: "Nanjing", sales: 310, country: "China" },
    { city: "Xi'an", sales: 260, country: "China" },
    { city: "Tianjin", sales: 270, country: "China" },
    { city: "New York", sales: 600, country: "USA" },
    { city: "Los Angeles", sales: 480, country: "USA" },
    { city: "Chicago", sales: 350, country: "USA" },
    { city: "Houston", sales: 400, country: "USA" },
    { city: "Phoenix", sales: 320, country: "USA" },
    { city: "Philadelphia", sales: 300, country: "USA" },
    { city: "San Antonio", sales: 280, country: "USA" },
    { city: "San Diego", sales: 290, country: "USA" },
    { city: "Dallas", sales: 310, country: "USA" },
    { city: "San Jose", sales: 270, country: "USA" },
  ];

  const config: ColumnConfig = {
    data,
    xField: "city",
    yField: "sales",
    slider: {
      x: {
        values: [0, 1],
      },
    },
    // Custom category color scheme
    // One height for all four, so the cards line up in the grid.
    height: 320,
    label: {
      position: "top",
      style: {
        fill: "#FFFFFF",
        opacity: 0.8,
      },
    },
  };

  return <Column {...config} ref={chartRef} />;
}
